export const getMedocData = () => ({
  name: "Médoc",
  region: "Bordeaux",
  country: "France",
  description: "Le Médoc est la région des grands crus classés de Bordeaux, célèbre pour ses vins rouges élégants et structurés. Cette région produit les vins les plus prestigieux de Bordeaux avec une hiérarchie établie depuis 1855.",
  type: "subregion",
  area: "16,500 ha",
  production: "800,000 hectolitres",
  mapAreas: [
    { region: "Médoc", x: -0.8, y: 45.2, color: "#4B164C", size: 6 }
  ],
  characteristics: {
    climate: "Climat océanique tempéré, étés chauds, hivers doux",
    soil: "Sols de graves et argiles, excellente structure",
    viticulture: "Rendements limités, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges structurés avec des tannins fermes et un excellent potentiel de vieillissement",
    white: "Vins blancs secs et aromatiques"
  },
  history: "La viticulture dans le Médoc remonte au XVIIe siècle. La classification de 1855 a établi la hiérarchie des crus classés. Le Médoc est devenu la référence mondiale pour les vins rouges de qualité. Aujourd'hui, le Médoc reste le symbole de l'excellence bordelaise.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, chocolat noir, cuisine française",
  grapeVarieties: [
    {
      name: "Cabernet Sauvignon",
      percentage: "60%",
      description: "Cépage principal du Médoc, apportant structure et tanins",
      characteristics: "Structuré, tanins fermes, notes de cassis et de cèdre",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Merlot",
      percentage: "30%",
      description: "Cépage d'assemblage, apportant rondeur et fruité",
      characteristics: "Fruité, tanins doux, structure équilibrée",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Cabernet Franc",
      percentage: "8%",
      description: "Cépage d'assemblage, apportant élégance et aromatique",
      characteristics: "Élégant, aromatique, tanins fins",
      wineStyles: "Sec, moyen-corps, aromatique"
    },
    {
      name: "Petit Verdot",
      percentage: "2%",
      description: "Cépage d'assemblage, apportant couleur et structure",
      characteristics: "Coloré, structuré, notes d'épices",
      wineStyles: "Sec, plein-corps, tannique"
    }
  ],
  subregions: {
    "haut-medoc": {
      name: "Haut-Médoc",
      description: "Zone nord du Médoc, produisant des vins de qualité",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Sols de graves",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        red: ["Cabernet Sauvignon", "Merlot", "Cabernet Franc"]
      },
      wineStyles: {
        red: "Vins rouges structurés et équilibrés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "margaux": {
      name: "Margaux",
      description: "Appellation prestigieuse, produisant des vins élégants",
      characteristics: {
        climate: "Climat optimal",
        soil: "Sols de graves fins",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        red: ["Cabernet Sauvignon", "Merlot", "Cabernet Franc"]
      },
      wineStyles: {
        red: "Vins rouges élégants et parfumés"
      },
      foodPairing: "Viandes rouges, volailles, fromages affinés"
    }
  }
}); 